import {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import LoadingSpinner from "../../components/Controls/LoadingSpinner/LoadingSpinner";
import "../../components/Pages/Code/Code.css";
import Select, { NonceProvider } from "react-select";
import "../../../src/Shared/Css/countryFlagStyles.css";
import { use } from "react";
import './RequestAccess.css'

const RequestAccess = forwardRef(function RequestAccess({onConfirmRequestAccess}, ref) {
  const [openLoader, setOpenLoader] = useState(false);
  const [modelMessage, setModelMessage] = useState("");

  const readerTranslations = useRef({
    emailText: "Email",
    firstNameText: "First Name",
    lastNameText: "Last Name",
    ok: "Ok",
    headerText: "Request Access",
    Reader_ID: "",
    NavigatingBnPagesPleaseWait: "",
    Reader_LoadingPleaseWait: "",
    optionalText:"(Optional)",
    title:"Enter email address and mobile number to request access for this document.",
  });

  const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true
  };

  const [mobileNum, setMobileNum] = useState("");
  const [modelopen, setOpen] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const [mobileCountryCode, setMobileCountryCode] = useState(null);
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const communicationChannel = useRef({});
  const readerOk = useRef("");
  const documentId = useRef("");
  const emailRef = useRef("");
  const [openScreen, setOpenScreen] = useState(false);
  const showOptionalPlaceholderText=useRef(false);


  useImperativeHandle(ref, () => {
    return {
      onShow(
        isOpen,
        docId,
        countryCodes,
        communication,
        showOptionalPlaceholder,
        translations
      ) {
        setOpenScreen(isOpen);
        documentId.current = docId;
        setSelectOptions(() => {
          return [...countryCodes];
        });
        if(emailRef.current)
          emailRef.current.value="";
        if(firstNameRef.current)
          firstNameRef.current.value="";
        if(lastNameRef.current)
          lastNameRef.current.value="";
        setMobileNum("");
        setMobileCountryCode("");
        communicationChannel.current = communication;
        showOptionalPlaceholderText.current=showOptionalPlaceholder;
        readerTranslations.current = { 
            ...readerTranslations.current,
            firstNameText: translations.firstNameText,
            lastNameText: translations.lastNameText,
            headerText: translations.headerText,
            NavigatingBnPagesPleaseWait: translations.navigationPleaseWait,
            Reader_LoadingPleaseWait: translations.loadingPleaseWait,
            Reader_ID:translations.readerId,
            readerOk:translations.Reader_OK,
            optionalText:`(${translations.optionalText})`,
            title:translations.title
        };
        
      },
    };
  });

  
 
  function handleMobileNum(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setMobileNum(event.target.value.trim());
    }
  }
  const handleMobileCountryCode = (e) => {
    if (e.languageCode == "ca") {
      const updatedOptions1 = selectOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "ca" || option.languageCode == "") {
          return {
            ...option,
            value: `${
              option.value.split("-")[0]
            }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setSelectOptions(updatedOptions1);
    }
    if (e.languageCode == "us") {
      const updatedOptions2 = selectOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "us" || option.languageCode == "") {
          return {
            ...option,
            value: `${
              option.value.split("-")[0]
            }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setSelectOptions(updatedOptions2);
    }
    e.value = e.value.split("-")[0];
    setMobileCountryCode(e);
  };
  const handleToClose = () => {
    setOpenLoader(false);
    setOpen(false);
  };
  const onConfirmationHandler = () => {

    if(emailRef.current.value.trim()==""){
      setOpen(true);
      setModelMessage("Email is required.");
      return;
    }
    
    if (
      (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailRef.current.value)) 
    ) {
      setOpen(true);
      setModelMessage("Please enter valid email.");
      return;
    }
      

    if(!showOptionalPlaceholderText.current){
      if (
        (mobileCountryCode.value == undefined ||
          mobileCountryCode.value == "+Code") &&
        mobileNum != ""
      ) {
        setOpen(true);
        setModelMessage("Please select country code.");
        return;
      }
    }

    const selectedCountry = selectOptions.find(
      (option) => option.value.split("-")[0] === mobileCountryCode?.value
    );

    const maxLength = selectedCountry ? selectedCountry.mobileMaxLeng : 10; // Default to 10 if no country is selected

    // Check if the input exceeds the max length
    if(!showOptionalPlaceholderText.current){
      if (
        mobileNum.length != maxLength &&
        mobileCountryCode.value !== "+Code" &&
        mobileCountryCode.value
      ) {
        setOpen(true);
        setModelMessage("Please enter valid mobile number.");
        return;
      }
    }
    
    if(!showOptionalPlaceholderText.current){
      if((mobileCountryCode.value == "+Code"||mobileCountryCode.value==undefined) && mobileNum==""){
        setOpen(true);
        setModelMessage("Mobile number is required.");
        return;
      }
    }
    
    setOpen(false);
    setOpenLoader(true);
    let firstName = firstNameRef.current.value.trim();
    let lastName = lastNameRef.current.value.trim();
    let MobileCountryCode =
      mobileCountryCode.value == undefined ||
      mobileCountryCode.value == "+Code"
        ? ""
        : mobileCountryCode.value;
    let MobileNumber = mobileNum;
    if (firstName.length === 0) firstName = "";
    if (lastName.length === 0) lastName = "";
    var url = `${process.env.REACT_APP_API}/docs/read/${documentId.current}`;
    //console.log({ ...rpdInfoData.current, firstName, lastName });
    const rpdInfo = {
      email:emailRef.current.value.trim(),
      firstName,
      lastName,
      mobileCountryCode: MobileCountryCode,
      mobileNumber: MobileNumber,
    };
    setOpenLoader(false);
    setOpenScreen(false);
    onConfirmRequestAccess(rpdInfo);

    // fetch(url, {
    //   mode: "cors",
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(rpdInfo),
    // })
    //   .then((response) => response.json())
    //   .then((response) => {
    //     //console.log(response);
    //     if (
    //       response.errorMessage != "" &&
    //       response.errorMessage == "Duplicate mobile number"
    //     ) {
    //       setOpen(true);
    //       setOpenLoader(false);
    //       setModelMessage("Duplicate mobile number is not allowed.");
    //       return;
    //     }
    //     if (response.authenticated) {
    //       //setOpenLoader(false);
    //       console.log(documentId.current);
    //       console.log(response.recipientId);
    //       // setCookie(
    //       //   documentId,
    //       //   response.recipientId,
    //       //   response.sessionExpireDate
    //       // );
    //       setOpenLoader(false);
    //       setOpen(false);
    //       // disclaimerRef.current.open(response.redirectUrl);
    //       //redirectUrlRef.current = response.redirectUrl;
    //       window.open(response.redirectUrl, "_self");
    //     }
    //   })
    //   .catch((error) => {
    //     setOpenLoader(false);
    //     console.log("Document read error");
    //   });
  };

  const onCancelHandler=()=>{
    setOpenScreen(false);
    if(emailRef.current)
      emailRef.current.value="";
    if(firstNameRef.current)
      firstNameRef.current.value="";
    if(lastNameRef.current)
      lastNameRef.current.value="";
    setMobileNum("");
    setMobileCountryCode("");
  }

  let content = <></>;
  if (
    communicationChannel.current.text &&
    communicationChannel.current.whatsApp
  ) {
    content = (
      <>
        <option value="Text">Text</option>
        <option value="WhatsApp">WhatsApp</option>
      </>
    );
  } else if (communicationChannel.current.whatsApp) {
    content = <option value="WhatsApp">WhatsApp</option>;
  } else if (communicationChannel.current.text) {
    content = <option value="Text">Text</option>;
  }
  return (
    <>
      {openScreen && (
        <>
          {openLoader && (
            <div className="spinerAuth-text ">
              <LoadingSpinner
                authenticatingMsg={readerTranslations.current.Reader_LoadingPleaseWait}
                class={"codeJs"}
              />
            </div>
          )}
          <div
            className="rpdFont modal"
            id="PagewModel"
            style={{ display: "block", backgroundColor: "#54404061" }}
            onContextMenu={(e) => e.preventDefault()}>
            <div className="modal-dialog modal-dialog-centered modal-customelg">
              <div className="modal-content">
                <div className="modal-body mt-0">
                  <div className="rpdFont ">
                    <div
                      className="rpdFont d-flex flex-column justify-content-center"
                      style={{ color: "#040921" }}>
                      <h1 className="text-center mb-0 mt-1 font-20px  res-font14 ">
                        {readerTranslations.current.headerText}
                      </h1>
                    </div>
                    <p className="rpdFont text-center mt-1 mb-0 info-text">
                      <span>{readerTranslations.current.title}</span>
                    </p>

                    <div className="rpdFont input-group mb-3 pb-2 mt-3 d-flex  justify-content-center">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "22px",
                              color: "#ffff",
                            }}>
                            person
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        ref={emailRef}
                        className="rpdFont form-control input_Person "
                        placeholder={readerTranslations.current.emailText}
                        maxLength={50}
                        // value={verifyEmail}
                        autoComplete="given-name"></input>
                    </div>
                    <div className="rpdFont input-group mb-3 pb-2 mt-3 d-flex  justify-content-center">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "22px",
                              color: "#ffff",
                            }}>
                            person
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        ref={firstNameRef}
                        className="rpdFont form-control input_Person "
                        placeholder={readerTranslations.current.firstNameText}
                        maxLength={50}
                        // value={verifyEmail}
                        autoComplete="given-name"></input>
                    </div>
                    <div className="rpdFont input-group mb-3 d-flex  justify-content-center">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{ fontSize: "22px", color: "#ffff" }}>
                            person
                          </i>
                        </span>
                      </div>

                      <input
                        type="text"
                        ref={lastNameRef}
                        className="rpdFont form-control input_Person "
                        placeholder={readerTranslations.current.lastNameText}
                        maxLength={50}
                        // value={passcode}
                        autoComplete="family-name"
                        //autoComplete="new-password"
                      ></input>
                    </div>

                    <div className="">
                      {(communicationChannel.current.text ||
                        communicationChannel.current.whatsApp) && (
                        <div className="rpdFont input-group mb-3 mt-4 d-flex justify-content-center mobile-select">
                          <div className="input-group-append">
                            <span className="input-group-text rp-text">
                              <i
                                className="material-icons"
                                style={{ fontSize: "22px", color: "#ffff" }}>
                                phone_iphone
                              </i>
                            </span>
                          </div>
                          <Select
                            value={mobileCountryCode ? mobileCountryCode : globePlaceholder}
                            onChange={handleMobileCountryCode}
                            //placeholder={data.label[0]}
                            options={selectOptions}
                            styles={{
                              placeholder: (base) => ({
                                ...base,
                                // color: "#888",
                                // fontStyle: "italic",
                              }),
                              control: (provided) => ({
                                ...provided,
                                height: "40px",
                                width: "130px",
                                border: "1px solid #ccc",
                                borderRadius: "0px 0 0 0px",
                                boxShadow: "none",
                                cursor: "pointer",
                                wordBreak: "normal",
                                // width: 'fit-content',
                                whiteSpace: "nowrap",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                width: "253px",
                                //marginTop: '18px',
                                maxHeight: "353px", // Limit height for scrolling
                                overflowY: "auto", // Enable vertical scrolling
                              }),
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                            //menuPortalTarget={document.body}
                            menuPosition="absolute"
                            //menuShouldScrollIntoView={false}
                            getOptionLabel={(e) => `${e.label}`}
                            getOptionValue={(e) => `${e.value}`}
                            formatOptionLabel={(data, { context }) => (
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                  className={`${data.label === "+Code"
                                                      ? "bg-  "
                                                      : `bg-${data.languageCode}`
                                                      }`}
                                  style={{
                                    width: "36px",
                                  }}></div>
                                {context === "menu"
                                  ? `${data.label}`
                                  : `${data.value.split("-")[0]}`}
                              </div>
                            )}
                            noOptionsMessage={() => null}
                          />
                          <input
                            id="mobile"
                            type="text"
                            className="rpdFont form-control input_user input-mobile"
                            placeholder={`Mobile ${showOptionalPlaceholderText.current ? readerTranslations.current.optionalText:""}`}
                            value={mobileNum}
                            onChange={handleMobileNum}
                            //onKeyUp={(e) => handleKeyUp(e)}
                          ></input>
                          {communicationChannel.current.text &&
                            communicationChannel.current.whatsApp && (
                              <select id="options">
                                <option value="">{"Select"}</option>
                                {content}
                              </select>
                            )}
                        </div>
                      )}
                    </div>
                    {/* <div className="rpdFont input-group mb-3 d-flex  justify-content-center">

        </div> */}
                    <div className="rpdFont d-flex justify-content-center mt-4 pt-1 login_container">
                      <button
                        type="button"
                        name="button"
                        className="rpdFont btn cancel me-3"
                        style={{ lineHeight: "1.6", fontSize: "17px" }}
                        onClick={onCancelHandler}>
                        {"Cancel"}
                      </button>
                      <button
                        type="submit"
                        name="button"
                        className="rpdFont btn login_btn  rp-btn"
                        style={{ lineHeight: "1.6", fontSize: "17px" }}
                        onClick={onConfirmationHandler}>
                        {readerTranslations.current.ok}
                      </button>
                    </div>
                    <div className="rpdFont">
                      <p className="rpdFont mb-0 doc-id">
                        {readerTranslations.current.Reader_ID} {documentId.current}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {modelopen === true && (
            <div
              className="modal"
              id="myModal1"
              style={{ display: "block", backgroundColor: "#8080801c" }}>
              <div className="modal-dialog modal-dialog-centered modal-customelg">
                <div className="modal-content">
                  <div className="modal-body" style={{ padding: "0.9rem" }}>
                    <h5
                      className={"text-center my-4 res-font14 rpdFont rd-text"}>
                      <span class="text-warn-text text-wrap-custom">
                        {modelMessage}
                      </span>
                    </h5>

                    <div className="mb-3 justify-content-center d-flex">
                      <button
                        type="button"
                        className="btn btn-secondary w-50 py-2"
                        data-bs-dismiss="modal"
                        style={{
                          background: "#040921",
                        }}
                        onClick={handleToClose}>
                        {readerTranslations.current.ok}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* <Disclaimer ref={disclaimerRef} /> */}
    </>
  );
});

export default RequestAccess;
